import type { IconData } from '@stacksjs/iconify-core'

export const balloon: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M27 16.824C27 11.3 22.97 8 18 8m0 33c.667 1.667 3 5 7 5c9 0 6.5-6 21-6\"/><path d=\"M33 16.118C33 24.954 26.284 34 18 34S3 24.954 3 16.118S9.716 2 18 2s15 5.281 15 14.118M16.192 40.953c-1.876-.1-2.778-1.653-1.677-3.175q.166-.23.359-.484C16.749 34.824 17.999 34 17.999 34s1.25.824 3.125 3.294q.192.254.359.484c1.101 1.522.199 3.075-1.677 3.175a34 34 0 0 1-3.614 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default balloon
